import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { FONTS } from "../../../styles/fonts";
import React from "react";
import { Link } from "react-router";
import { wrapperStyles, xxxStyles } from "./spare-parts-navigation";
import { InternalLinkProps } from "../sitemap/plp-sitemap";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../../components/T";
export const LinkableContent: ReactTFC<{
  text: string;
  label: string | TranslatedValue;
  link: InternalLinkProps | undefined;
  isCurrentlySelected: boolean;
}> = ({ text, label, link, isCurrentlySelected }) => {
  const ContentElement = <Content text={text} label={label} />;

  if (link && !isCurrentlySelected) {
    return (
      <Link to={link} css={[wrapperStyles, xxxStyles]}>
        {ContentElement}
      </Link>
    );
  } else {
    return <span css={[wrapperStyles, xxxStyles]}>{ContentElement}</span>;
  }
};

export const Content: ReactTFC<{ text: string; label: string | TranslatedValue }> = props => (
  <>
    <span
      css={css`
        border: 1px solid ${CSS_COLORS.Grey2};

        .checked & {
          background-color: ${CSS_COLORS.Green};
          color: ${CSS_COLORS.White};
          border: 1px solid ${CSS_COLORS.Green};
        }

        .active & {
          background-color: ${CSS_COLORS.White};
          color: ${CSS_COLORS.Green};
          border: 1px solid ${CSS_COLORS.Green};

          box-shadow: 0 0 4px 0 ${CSS_COLORS.Green};
        }

        .disabled & {
          background-color: ${CSS_COLORS.White};
          color: ${CSS_COLORS.Grey2};
          border: 1px solid ${CSS_COLORS.Grey2};

          box-shadow: none;
        }

        font-family: ${FONTS.SwarovskiFutura500};
        font-size: var(--font-size);
        text-align: center;

        display: flex;
        justify-content: center;
        align-items: center;

        width: var(--size);
        height: var(--size);

        border-radius: 100%;
        border: 1px solid ${CSS_COLORS.Green};
      `}
    >
      <span
        css={css`
          margin-top: 4px; // center visually
        `}
      >
        {props.text}
      </span>
    </span>
    <span
      className={"_label"}
      css={css`
        position: absolute;
        width: calc(var(--gap));
        text-align: center;
        top: calc(100% + 10px);

        transform: translateX(-50%);
        left: 50%;
      `}
    >
      <T>{props.label}</T>
    </span>
  </>
);
